import { lazy } from 'react';

/** Загружает карточку шаблона промокодов */
export const PromoCodeTemplateDetailsPageAsync = lazy(() => import('./PromoCodeTemplateDetailsPage'));
